import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import RateQualifierGeneralDetails from "./rateQualifierGeneralDetails";
import { useState, useEffect } from "react";
import CarInsurance from "./carInsurance";
const CarDetailsDescription = ({ myData, mysteryCar, collection, renters, renter, checkout, showCheckout, operationEnded, applyDiscount, t, onlyOnDestination, IsDomestic, market, allInclusiveOffer, }) => {
    const [width, setWidth] = useState(window.innerWidth);
    const [currentURL, setCurrentURL] = useState(window.location.href);
    const country = sessionStorage.getItem("country") || "US";
    const pickCountry = sessionStorage.getItem("pickCountry") || "US";
    useEffect(() => {
        window.addEventListener("resize", () => {
            setWidth(window.innerWidth);
        });
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(RateQualifierGeneralDetails, { myData: myData.renter.rateQualifier[0], renters: renters, renter: renter, width: width, applyDiscount: applyDiscount, allInclusiveOffer: allInclusiveOffer }), operationEnded && country != pickCountry && (_jsx(CarInsurance, { width: width, t: t, market: pickCountry }))] }));
};
export default CarDetailsDescription;
